import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface RulesUIState {
  searchQuery: string;
  severityFilter: string;
}

const initialState: RulesUIState = {
  searchQuery: '',
  severityFilter: '',
};

const rulesSlice = createSlice({
  name: 'rulesUI',
  initialState,
  reducers: {
    setRulesSearchQuery(state, action: PayloadAction<string>) {
      state.searchQuery = action.payload;
    },
    setRulesSeverityFilter(state, action: PayloadAction<string>) {
      state.severityFilter = action.payload;
    },
  },
});

export const { setRulesSearchQuery, setRulesSeverityFilter } = rulesSlice.actions;
export default rulesSlice.reducer;
